import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';

@Injectable()
export class CarrierService {

  public carrierUrl = environment.runtime.userManagementApiUrl;
  public userUrl = environment.runtime.userManagementApiUrl;
  public all: {}[] = [];
  public newCarrierUser: any = {};
  public initialCarrierUnit: any = {};
  public carrierUnit: any = {};
  public updatedCarrierUser: any = { organization: {} };
  public nameIsInvalid: boolean = false;
  public emailIsInvalid: boolean = false;
  public invalidNameErrorMessage: string = '';
  public currentCarrierID: string = '';
  public requestId: string;
  public isFactoringCompany: boolean = false;
  public factoringCode: any;


  constructor(private authHttp: HttpClient, private errorHandlerService: ErrorHandlerService) { }

  getCarrierUnit(id: string) {
    return this.authHttp.get(`${this.carrierUrl}/carrier/unit/` + id).toPromise()
      .then(response => response)
      .catch(e => this.errorHandlerService.handleError(e, e.json().message));
  }

  getCarriers(searchText: string) {
    return this.authHttp.get(`${this.carrierUrl}/carrier/search?carrierName=${encodeURIComponent(searchText)}`)
  }

  getCarriersTextSearch(searchText: string) {
    return this.authHttp.get(`${this.carrierUrl}/carrier/textsearch?text=${encodeURIComponent(searchText)}`)
  }

  getFactoringCompanies(searchText: string) {
    return this.authHttp.get(`${this.carrierUrl}/factoring-companies?factoringCompName=${encodeURIComponent(searchText)}`);
  }

  getCarrier(id: string): {} {
    return this.all.filter(carrier => carrier['sourceId'] === id)[0];
  }

  getCarrierUsers(id: string) {
    return this.authHttp.get(`${this.carrierUrl}/users/` + id)
      .toPromise()
      .then(response => response)
      .catch(e => this.errorHandlerService.handleError(e, e.json().message));
  }

  getCarrierDetail(id: string) {
    return this.authHttp.get(`${this.carrierUrl}/carrier/` + id)
      .toPromise()
      .then(response => response)
      .catch(e => this.errorHandlerService.handleError(e, e.json().message));
  }

  getFactoringCompanyDetail(id: string) {
    return this.authHttp.get(`${this.carrierUrl}/factoring-company/` + id)
      .toPromise()
      .then(response => response)
      .catch(e => this.errorHandlerService.handleError(e, e.json().message));
  }

  public changeCarrierId(id) {
    this.currentCarrierID = id;
  }

  public changeCarrier(carrier) {
    this.updatedCarrierUser.organization['organizationName'] = carrier.carrierName;
    this.updatedCarrierUser.organization['organizationCode'] = carrier.sourceId;
  }

  public updateCarrierUnit(carrierID: string) {
    this.getCarrierUnit(carrierID).then(carrier => {
      this.initialCarrierUnit.businessUnit = carrier.businessUnit;
      this.initialCarrierUnit.transportMode = carrier.transportMode;
      this.carrierUnit.businessUnit = carrier.businessUnit || ['HWY'];
      this.carrierUnit.transportMode = carrier.transportMode || 'TL';
    });
  }

  public shouldUpdateCarrierUnit() {
    return this.initialCarrierUnit.businessUnit !== this.carrierUnit.businessUnit ||
    this.initialCarrierUnit.transportMode !== this.carrierUnit.transportMode;
  }

  public invalidName(event, name) {
    let invalidPattern = event.srcElement.validity.patternMismatch;
    if (!invalidPattern) {
      this.nameIsInvalid = false;
    } else if (invalidPattern && name.includes('  ')) {
      this.nameIsInvalid = true;
      this.invalidNameErrorMessage = "Please enter both a first and last name seperated by single space characters";
    } else if (invalidPattern && !name.includes('  ')) {
      this.nameIsInvalid = true;
      this.invalidNameErrorMessage = "Please enter both a first and last name";
    }
  }

  public invalidEmail(event) {
    let invalidPattern = event.srcElement.validity.patternMismatch;
    if (invalidPattern) {
      this.emailIsInvalid = true;
    } else {
      this.emailIsInvalid = false;
    }
  }

  getCarrierUser(id: string): Promise<{}[]> {
    return this.authHttp.get(`${this.userUrl}/user/get/` + id)
      .toPromise()
      .then(response => response)
      .catch(e => this.errorHandlerService.handleError(e, e.json().message));
  }

  getCarrierAffiliatedUser(id: string, orgId: string): Promise<{}[]> {
    if (orgId) {
      return this.authHttp.get(`${this.userUrl}/user/get/${id}/organization/${orgId}`)
        .toPromise()
        .then(response => response)
        .catch(e => this.errorHandlerService.handleError(e, e.json().message));
    } else {
      return this.getCarrierUser(id);
    } 
  }

  createCarrierUser(): Promise<{}[]> {
    if (this.newCarrierUser.requestType && this.newCarrierUser.requestType === 'FACTORING COMPANY') {
      this.newCarrierUser.roleCode = 'HC_CR_FACTORING_ADMIN'
    }
    return this.authHttp.post(`${this.userUrl}/user/create`, this.newCarrierUser)
      .toPromise()
      .then(response => response)
      .catch(e => this.errorHandlerService.handleError(e.error.error));
  }

  updateCarrierUser(id: string): Promise<{}[]> {
    return this.authHttp.post(`${this.userUrl}/user/update/other/` + id, this.updatedCarrierUser)
      .toPromise()
      .then(response => response)
      .catch(e => this.errorHandlerService.handleError(e, e.json().message));
  }

  updateCarrierAffiliatedUser(id: string, orgId: string): Promise<{}[]> {
    if (orgId) {
    return this.authHttp.post(`${this.userUrl}/user/update/other/${id}/organization/${orgId}`, this.updatedCarrierUser)
      .toPromise()
      .then(response => response)
      .catch(e => this.errorHandlerService.handleError(e, e.json().message));
    } else {
      return this.updateCarrierUser(id);
    }
  }

  resetCarrierUser(): void {
    this.newCarrierUser = {};
    this.initialCarrierUnit = {};
    this.carrierUnit = {};
  };

  createCarrierRequest(carrierUserRequest, token): Promise<{}[]> {
    const isCordovaApp = document.URL.indexOf('http://') === -1
    let url = `${this.carrierUrl}/carrier-user-request/${token}`;
    if (isCordovaApp) {
      url = window.location.origin;
      url = url + `/hubconnectusermanagementapi/carrier-user-request/${token}`
    }
    return this.authHttp.post(url, carrierUserRequest)
      .toPromise()
      .then(response => response)
      .catch(e => this.errorHandlerService.handleError(e.error.error))
  }

  validateToken(urlString: string, token: string): Promise<{}[]> {
    let status = urlString === 'validate' ? 'validate' : 'confirm';
    const isCordovaApp = document.URL.indexOf('http://') === -1
    let url = `${this.carrierUrl}/validate-token/${status}/${token}`;
    if (isCordovaApp) {
      url = window.location.origin;
      url = url + `/hubconnectusermanagementapi/validate-token/${status}/${token}`
    }
    return this.authHttp.get(url)
      .toPromise()
      .then(response => response)
      .catch(e => this.errorHandlerService.handleError(e.error.error))
  }

  getVendorLocations(carrierId: string) {
    return this.authHttp.get(`${this.carrierUrl}/carrier/vendor_locations/${carrierId}`);
  }

}
